import { render, staticRenderFns } from "./ReferContactRewardsDialog.vue?vue&type=template&id=29787132"
import script from "./ReferContactRewardsDialog.vue?vue&type=script&lang=ts"
export * from "./ReferContactRewardsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReferContactRewardsDialog.vue?vue&type=style&index=0&id=29787132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports